import React from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { usePortfolioData } from "../contexts/DataContext";
import "./styles/ResearchSection.css";

const fadeUp = {
	hidden: { opacity: 0, y: 20 },
	visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const stagger = {
	hidden: {},
	visible: { transition: { staggerChildren: 0.04 } },
};

const child = {
	hidden: { opacity: 0, x: -8 },
	visible: { opacity: 1, x: 0, transition: { duration: 0.3 } },
};

const ResearchSection = () => {
	const { data: INFO } = usePortfolioData();
	if (!INFO.research || INFO.research.length === 0) return null;

	return (
		<section className="rsch">
			<div className="content-wrapper">
				<motion.div
					className="rsch__header"
					variants={fadeUp}
					initial="hidden"
					whileInView="visible"
					viewport={{ once: true }}
				>
					<span className="rsch__label">Stuff I'm trying to figure out</span>
					<h1 className="rsch__title">Research</h1>
				</motion.div>

				{INFO.research.map((project, idx) => (
					<motion.article
						key={idx}
						className="rsch__paper"
						variants={fadeUp}
						initial="hidden"
						whileInView="visible"
						viewport={{ once: true }}
					>
						<div className="rsch__paper-head">
							<h2 className="rsch__paper-title">{project.title}</h2>
							<span className="rsch__paper-date">{project.subtitle}</span>
						</div>

						<div className="rsch__paper-abstract">
							<span className="rsch__abstract-label">What it's about</span>
							<p>{project.description}</p>
						</div>

						{project.components && (
							<motion.div
								className="rsch__paper-body"
								variants={stagger}
								initial="hidden"
								whileInView="visible"
								viewport={{ once: true }}
							>
								<span className="rsch__body-label">What I'm building for this</span>
								<div className="rsch__components">
									{project.components.map((c, i) => (
										<motion.div key={i} className="rsch__component" variants={child}>
											<FontAwesomeIcon icon={faChevronRight} className="rsch__component-icon" />
											<span>{c}</span>
										</motion.div>
									))}
								</div>
							</motion.div>
						)}

						<div className="rsch__paper-footer">
							<div className="rsch__paper-tags">
								{project.tags.map((t) => (
									<span key={t}>{t}</span>
								))}
							</div>
							{project.link && (
								<a href={project.link} target="_blank" rel="noopener noreferrer" className="rsch__paper-link">
									Repository <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
								</a>
							)}
						</div>
					</motion.article>
				))}
			</div>
		</section>
	);
};

export default ResearchSection;
